import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Field, Form } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { actions } from '../../../../context';

const PluginClientCommandConfirmationModal = (props) => {
    const dispatch = useDispatch();

    const { instanceId, pluginId, type, toggle, isOpen } = props;

    const close = useCallback(() => {
        toggle();
        //TO DO: We need to implement maybe a refresh if we need to update the version on the list
        //refresh();
    }, [toggle]);

    const submit = async (vals) => {
        switch (type) {
            case 'Start':
                dispatch(actions.clientPlugins.triggerInitiateStateCommand(
                    instanceId,
                    pluginId,
                    type,
                    vals?.message
                ));
                break;
            case 'Stop':
                dispatch(actions.clientPlugins.triggerInitiateStateCommand(
                    instanceId,
                    pluginId,
                    type,
                    vals?.message
                ))
                break;
            case 'Restart':
                dispatch(actions.clientPlugins.triggerInitiateStateCommand(
                    instanceId,
                    pluginId,
                    type,
                    vals?.message
                ))
                break;
            default:
                console.log('command type not found');
        }

        close();
    };

    const modalProps = {className: 'text-light', style: { minWidth: '30vw' }, backdrop: "static"};

    return (
        <Modal
            className="text-light"
            centered
            isOpen={isOpen}
            toggle={close}
            {...modalProps}>
            <Form
                onSubmit={submit}
                render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>
                            <span>
                                <FontAwesomeIcon
                                    size="lg"
                                    color='yellow'
                                    title="This practice has a conversion offering"
                                    icon={faExclamationTriangle}
                                />
                                &nbsp;
                                Confirm Command {type}
                            </span>
                        </ModalHeader>
                        <ModalBody>
                            <Field
                                className="w-100 p-2 rounded my-2"
                                component="textarea"
                                name="message"
                                placeholder={`Please include a reason for this ${type.toLowerCase()}`}
                                required
                                rows="4"
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="danger"
                                onClick={() =>
                                    pristine ? close() : form.reset()
                                }
                                disabled={submitting}>
                                {pristine ? 'Cancel' : 'Clear'}
                            </Button>
                            <Button
                                color="success"
                                disabled={pristine || submitting}>
                                Confirm
                            </Button>
                        </ModalFooter>
                    </form>
                )}
            />
        </Modal>
    );
};

export default PluginClientCommandConfirmationModal;